import React, { useState, useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { gamificationService, UserStreak } from '../../services/gamificationService';
import MaterialSymbol from '../common/MaterialSymbol';

/**
 * "Aktuelle Serie" — Streak-Panel im neuen Design (.streak).
 * Re-Skin von components/Gamification/StreakDisplay (das bleibt für
 * "Meine Erfolge" unverändert): gleicher Datenabruf via
 * gamificationService.getMyStreak, gleiche Zustände (loading/at-risk).
 */
const StreakWidget: React.FC = () => {
    const translate = useTranslate();
    const [streak, setStreak] = useState<UserStreak | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadStreak = async () => {
            try {
                const data = await gamificationService.getMyStreak();
                setStreak(data);
            } catch (error) {
                console.error('Failed to load streak:', error);
            } finally {
                setLoading(false);
            }
        };
        loadStreak();
    }, []);

    if (loading) {
        return (
            <div className="panel">
                <div className="skel" />
            </div>
        );
    }

    if (!streak) {
        return null;
    }

    const { currentStreak, longestStreak, isAtRisk } = streak;

    return (
        <div className="panel">
            <div className="streak">
                <span className="flame"><MaterialSymbol name="local_fire_department" size={32} /></span>
                <div>
                    <div className="big">{currentStreak} {translate('gamification.days')}</div>
                    <div className="cap">{translate('gamification.currentStreak')}</div>
                    {isAtRisk && (
                        <div className="risk">
                            <MaterialSymbol name="warning" size={14} />
                            {translate('gamification.streakAtRiskMessage')}
                        </div>
                    )}
                </div>
                <div className="right">
                    {translate('gamification.longestStreak')}
                    <b>{longestStreak} {translate('gamification.days')}</b>
                </div>
            </div>
        </div>
    );
};

export default StreakWidget;
